/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Scholarship_PrefixInputs */

const en_faq_scholarship_prefix = /** @type {(inputs: Faq_Scholarship_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got questions about the`)
};

const es_faq_scholarship_prefix = /** @type {(inputs: Faq_Scholarship_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes preguntas sobre la`)
};

/**
* | output |
* | --- |
* | "Got questions about the" |
*
* @param {Faq_Scholarship_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_scholarship_prefix = /** @type {((inputs?: Faq_Scholarship_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Scholarship_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_scholarship_prefix(inputs)
	return en_faq_scholarship_prefix(inputs)
});